import { ChangeDetectionStrategy, Component, inject, OnInit, output, signal } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { AuthenticationService } from '../../services';
import { KeycloakProfile } from 'keycloak-js';
import { MaterialIconComponent } from '../material-icon/material-icon.component';
import { FloatingMenuComponent, FloatingMenuItemComponent } from '../floating-menu';
import { NativeElementHook } from '../../directives/native-element-hook.directive';

@Component({
  selector: 'shared-core-header',
  imports: [
    CommonModule,
    NgOptimizedImage,
    MaterialIconComponent,
    FloatingMenuComponent,
    FloatingMenuItemComponent,
    NativeElementHook,
  ],
  templateUrl: './header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent implements OnInit {
  private readonly authenticationService = inject(AuthenticationService);

  logoClicked = output();

  protected readonly usersFullName = signal<string>('');

  userMenuItems: { label: string; callback: () => void }[] = [
    {
      label: 'Log out',
      callback: () => this.logout(),
    },
  ];

  readonly isUserMenuOpened = signal(false);

  ngOnInit() {
    this.authenticationService.loadUserProfile().then((userProfile: KeycloakProfile) => {
      const first = userProfile.firstName;
      const last = userProfile.lastName;
      this.usersFullName.set(first && last ? `${first} ${last}` : userProfile.username!);
    });
  }

  private logout(): void {
    this.authenticationService.logout();
  }

  protected onLogoClicked() {
    this.logoClicked.emit();
  }

  toggleIsUserMenuOpened(event: MouseEvent) {
    event.stopPropagation();
    this.isUserMenuOpened.update((bool) => !bool);
  }
}
